export const encodeEmailUtil = (input) => input
    .split("")
    .map((char) => `&#${char.charCodeAt(0)};`)
    .join("");
export default encodeEmailUtil;
